module.exports = __webpack_public_path__ + "tomatoes.jpg?05491cee74c31f01d3178ea19f52fad9";


//////////////////
// WEBPACK FOOTER
// ./IMG/tomatoes.jpg
// module id = 37
// module chunks = 0